produtos.component('produtos.produtosModalComponent', {
    templateUrl: 'produtos/produtosModal/produtosModal.html',
    controller: 'produtos.produtosModalController',
    controllerAs: '$modal',
    bindings: { config: '=' }
});

produtos.controller('produtos.produtosModalController', ['$scope', 'coreLanguage', 'coreFb', function($scope, $text, $fb) {
    const $ctrl = this;
    $scope.$text = $text;

    const formErrosDefault = {
        nome:{}
    };

    $ctrl.close=()=>{
        $ctrl.config.show = false;
        $ctrl.formErrors = formErrosDefault;
    };

    $ctrl.onBlur = (field) => {
        $ctrl.formErrors[field] = {
            field: !$scope.formContato[field].$valid,
            hint: !$scope.formContato[field].$valid
        };
    };

    $ctrl.validateForm=()=>{
        if($scope.formContato.$valid){
            $ctrl.config.confirm();
        }else{
            Object.keys(formErrosDefault).forEach(key=>{ $ctrl.onBlur(key); });
        }
    };

    $scope.$watch('$modal.config.show', (newValue) => {
        if(newValue){ 
            $ctrl.formErrors = angular.copy(formErrosDefault);
        }
    });

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idUsuario;
    }

}]);